<div class="body-container">
  <!-- grid -->
  <app-grid
    [gridBulkSection]=false
    [gridColumnsParam]=gridColumnsParam
    [gridFilter]=true
    [gridFiltersParam]=gridFiltersParam
    [gridPanelPreferences]=false
    [sectionMessage]=true
    [gridSearchNotFoundDescription]=gridSearchNotFoundDescription
    (onGetGridData)="getEvents()">
    <mat-list matSort (matSortChange)="_grid.onSortData($event)" class="custom-mat-list list-grid-std list-events">
      <!-- header -->
      <mat-list-item *ngIf="_skeleton.skeletonGridDataLoader" class="custom-mat-list-item grid-row grid-row-header">
        <div class="cell-wrapper col-first">
          <div class="cell col-date flex-order order-0">
            <label matLine class="label-header">Date</label>
          </div>
        </div>
        <div class="cell-wrapper col-info">
          <div class="cell col-event flex-order order-{{_meta.collectionOfMetaFields[gridCols.eventsInfo]?.priority}}">
            <label matLine class="label-header">Event</label>
          </div>
          <div class="cell col-user flex-order order-{{_meta.collectionOfMetaFields[gridCols.eventsUser]?.priority}}">
            <label matLine class="label-header">User</label>
          </div>
          <div class="cell col-source flex-order order-{{_meta.collectionOfMetaFields[gridCols.eventsSource]?.priority}}">
            <label matLine class="label-header">Source</label>
          </div>
        </div>
        <div class="cell-wrapper col-actions">
          <div class="cell"></div>
        </div>
      </mat-list-item>

      <skeleton-loader-grid-header></skeleton-loader-grid-header>

      <!-- rows -->
      <div *ngIf="_skeleton.skeletonGridDataLoader">
        <mat-list-item *ngFor="let event of _grid.collectionOfGridItems; let i = index;" class="custom-mat-list-item grid-row">
          <div class="cell-wrapper col-first">
            <div class="cell col-date flex-order order-0">
              <label class="status">
                <div [class]="'status-inner'" [ngClass]="{ 'status-info': event.level == _logStatus.info, 'status-error': event.level == _logStatus.error, 'status-warning': event.level == _logStatus.warning }">
                  <span *ngIf="event.level == _logStatus.info" class="status-label">Info</span>
                  <span *ngIf="event.level == _logStatus.warning" class="status-label">Warning</span>
                  <span *ngIf="event.level == _logStatus.error" class="status-label">Error</span>
                </div>
              </label>
              <div class="cell-inner cell-inner-with-status">
                <label matLine class="label-primary">{{ event.createdAt | dateTz }}</label>
                <label matLine class="label-secondary">{{ event.createdAt | dateTz : 'longTime' }}</label>
              </div>
            </div>
          </div>
          <div class="cell-wrapper col-info">
            <div class="cell col-event flex-order order-1">
              <label matLine class="label-primary">{{ event.name }}</label>
            </div>
            <div class="cell col-user flex-order order-2">
              <div *ngIf="event.user" class="cell-inner">
                <label matLine class="label-primary">{{ event.user.firstName }} {{ event.user.lastName }}</label>
                <label matLine class="label-secondary">{{ event.user.username }}</label>
              </div>
              <label matLine *ngIf="!event.user" class="label-primary">-</label>
            </div>
            <div class="cell col-source flex-order order-3">
              <label matLine class="label-primary">{{ event.source | titlecase}}</label>
            </div>
            <!--
              <div class="cell col-level flex-order order-4">
                <label matLine class="label-primary">{{ event.level | titlecase }}</label>
              </div>
            -->
          </div>
          <div class="cell-wrapper col-actions">
            <button mat-icon-button [matMenuTriggerFor]="gridActions" class="custom-mat-icon-button button-actions">
              <mat-icon svgIcon="ico-actions" class="custom-mat-icon ico-size ico-xs"></mat-icon>
            </button>
            <mat-menu #gridActions="matMenu" [overlapTrigger]="false" class="custom-mat-menu-panel">
              <a mat-menu-item [routerLink]="['../event-detail/', event.id]" class="custom-mat-menu-item has--no--icon">View Details</a>
            </mat-menu>
          </div>
        </mat-list-item>
      </div>

      <skeleton-loader-grid-body></skeleton-loader-grid-body>

    </mat-list>
  </app-grid>
</div>
